import React from 'react';
import { Modal, Form, Button, Select, InputNumber, Input, Spin } from 'antd';
const { Option } = Select;

const PdfOptionsModal = ({
  visible,
  onCancel,
  onSubmit,
  footerText,
  setFooterText,
  footerFontSize,
  setFooterFontSize,
  headerTextForTOC,
  setHeaderTextForTOC,
  headerTextForLOT,
  setHeaderTextForLOT,
  alignment,
  setAlignment,
  indentationMargin,
  setIndentationMargin,
  colorForTocLot,
  setColorForTocLot,
  loading,
}) => {
  const handleFinish = (pdfOptions) => {
    Modal.confirm({
      title: 'Choose Action',
      content:
        'Do you want to generate the report now or schedule it to be sent later?',
      okText: 'Generate Now',
      cancelText: 'Schedule Report',
      onOk: () => {
        onSubmit({ ...pdfOptions, schedule: false });
      },
      onCancel: () => {
        onSubmit({ ...pdfOptions, schedule: true });
      },
    });
  };

  return (
    <Modal
      title="Select Whole Report's PDF Options"
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Spin tip="This process may take time." spinning={loading}>
        <Form layout="vertical" onFinish={handleFinish}>
          {/* Table Options Section */}
          <Form.Item
            name="font_family"
            label="Font Family"
            rules={[{ required: true, message: 'Please select a font family' }]}
          >
            <Select placeholder="Select Font Family">
              <Option value="Arial">Arial</Option>
              {/* Add other font options as needed */}
            </Select>
          </Form.Item>
          <Form.Item
            name="table_alignment"
            label="Table Alignment"
            rules={[
              { required: true, message: 'Please select text alignment' },
            ]}
          >
            <Select placeholder="Select Text Alignment">
              <Option value="left">Left</Option>
              <Option value="center">Center</Option>
              <Option value="right">Right</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="font_size"
            label="Font Size"
            rules={[{ required: false, message: 'Please enter a font size' }]}
          >
            <InputNumber style={{ width: '100%' }} min={1} />
          </Form.Item>
          <Form.Item
            name="custom_table_number"
            label="Custom Table Number"
            rules={[
              {
                required: false,
                message: 'You can enter a custom table number',
              },
            ]}
          >
            <Input placeholder="1.1, 1.2" />
          </Form.Item>
          <Form.Item
            name="custom_table_title"
            label="Custom Table Title"
            rules={[
              {
                required: false,
                message: 'You can enter a custom table title',
              },
            ]}
          >
            <Input placeholder="Table x.x: Indicator Name" />
          </Form.Item>
          <Form.Item
            name="header_height"
            label="Header Height"
            rules={[
              { required: false, message: 'Please enter header height' },
            ]}
          >
            <InputNumber style={{ width: '100%' }} min={1} />
          </Form.Item>
          <Form.Item
            name="row_height"
            label="Row Height"
            rules={[
              { required: false, message: 'Please enter row height' },
            ]}
          >
            <InputNumber style={{ width: '100%' }} min={1} />
          </Form.Item>
          <Form.Item
            name="header_fill_color"
            label="Header Fill Color (R,G,B)"
            rules={[
              { required: false, message: 'Please enter header fill color' },
            ]}
          >
            <Input placeholder="e.g., 0,70,132" />
          </Form.Item>
          <Form.Item
            name="header_text_color"
            label="Header Text Color (R,G,B)"
            rules={[
              { required: false, message: 'Please enter header text color' },
            ]}
          >
            <Input placeholder="e.g., 255,255,255" />
          </Form.Item>
          <Form.Item
            name="row_fill_color"
            label="Row Fill Color (R,G,B)"
            rules={[
              { required: false, message: 'Please enter row fill color' },
            ]}
          >
            <Input placeholder="e.g., 217,225,242" />
          </Form.Item>
          <Form.Item
            name="bold_line_thickness"
            label="Bold Line Thickness"
            rules={[
              {
                required: false,
                message: 'Please enter bold line thickness',
              },
            ]}
          >
            <InputNumber style={{ width: '100%' }} min={0.1} step={0.1} />
          </Form.Item>

          {/* Content Page Options Section */}
          <div
            style={{
              marginTop: 16,
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1rem',
            }}
          >
            <div style={{ flex: '1 1 200px' }}>
              <label>Footer Text:</label>
              <Input
                placeholder="Statistical Yearbook..."
                value={footerText}
                onChange={(e) => setFooterText(e.target.value)}
              />
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label>Footer Font Size:</label>
              <Input
                type="number"
                placeholder="11"
                value={footerFontSize}
                onChange={(e) => setFooterFontSize(e.target.value)}
              />
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label>Header Text for TOC:</label>
              <Input
                placeholder="Table of Contents"
                value={headerTextForTOC}
                onChange={(e) => setHeaderTextForTOC(e.target.value)}
              />
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label>Header Text for LOT:</label>
              <Input
                placeholder="List of Tables"
                value={headerTextForLOT}
                onChange={(e) => setHeaderTextForLOT(e.target.value)}
              />
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label>Content Page Alignment:</label>
              <Select
                value={alignment}
                onChange={(val) => setAlignment(val)}
                style={{ width: '100%' }}
                placeholder="L / C / R"
              >
                <Option value="L">Left</Option>
                <Option value="C">Center</Option>
                <Option value="R">Right</Option>
              </Select>
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label>Indentation Margin:</label>
              <Input
                type="number"
                placeholder="20"
                value={indentationMargin}
                onChange={(e) => setIndentationMargin(e.target.value)}
              />
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label>Color for TOC/LOT (R,G,B):</label>
              <Input
                placeholder="0,112,192"
                value={colorForTocLot}
                onChange={(e) => setColorForTocLot(e.target.value)}
              />
            </div>
          </div>

          <Form.Item style={{ marginTop: 16 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default PdfOptionsModal;
